/*
 * 玻璃公共样式
 */

.wui-glass {
  position: relative;

  background-color: var(--wui-color-surface-glass, rgb(250 250 250 / 0.34));
  background-image: linear-gradient(
    to bottom,
    color-mix(in srgb, var(--wui-color-glass-highlight, rgb(255 255 255 / 0.9)) 20%, transparent),
    color-mix(in srgb, var(--wui-color-glass-highlight, rgb(255 255 255 / 0.9)) 4%, transparent) 48%,
    transparent
  );
  background-clip: padding-box;

  /* Safari 16.4 只支持带 -webkit- 前缀的 backdrop-filter（无前缀 18 才支持），
     lightningcss 对 ?inline 导入不做自动前缀，需手动写前缀版本 */
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-backdrop-filter: blur(4px) saturate(160%) brightness(1.06);
  backdrop-filter: blur(4px) saturate(160%) brightness(1.06);
  box-shadow:
    inset 0 0 0 0.5px color-mix(in srgb, var(--wui-color-glass-highlight, rgb(255 255 255 / 0.9)) 38%, transparent),
    inset 0 1px 0.5px color-mix(in srgb, var(--wui-color-glass-highlight, rgb(255 255 255 / 0.9)) 52%, transparent),
    inset 0 -0.5px 1px rgb(0 0 0 / 0.03),
    var(--wui-internal-glass-focus-ring, 0 0 0 0 transparent),
    var(
      --wui-internal-glass-shadow,
      var(
        --wui-shadow-glass,
        0 0 1px rgb(0 0 0 / 0.05),
        0 0 8px rgb(0 0 0 / 0.03),
        0 2px 16px rgb(0 0 0 / 0.025),
        0 8px 32px rgb(0 0 0 / 0.015)
      )
    );
}
